import './stylesExportToXlsxButton.css';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import { DownloadOutlined } from '@ant-design/icons';

const ExportToXlsxButton = ({ data, filename }) => {
  const exportToExcel = () => {
    if (!data || data?.length === 0) {
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    const fileData = new Blob([excelBuffer], {
      type: 'application/octet-stream',
    });
    saveAs(fileData, filename);
  };

  return (
    <button
      onClick={exportToExcel}
      className={`export-to-xlsx-button ${
        data?.length === 0 ? 'disabled' : ''
      }`}
    >
      <DownloadOutlined className="download-icon" />
    </button>
  );
};

export default ExportToXlsxButton;
